import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import StarFill from '@deliveroo/icon-set/react/StarFill';
import Icon from '@deliveroo/consumer-component-library/components/Icon';

import styles from './styles.scss';

export default function OrderRatingStars({ selectedRating, onChange }) {
  const renderStar = (number) => (
    <Fragment>
      <input
        className={styles.input}
        // prefix to prevent duplicate IDs on mobile and dekstop
        id={`rating_star_${number}`}
        name={`rating_star_${number}`}
        type="radio"
        value={number}
        checked={selectedRating === number}
        onChange={onChange}
      />
      <label className={styles.label} htmlFor={`rating_star_${number}`}>
        <Icon component={StarFill} size={36} />
        {`${number} stars`}
      </label>
    </Fragment>
  );

  return (
    <div className={styles.container}>
      {/* Reverse order to make CSS RTL trick work */}
      {renderStar('5')}
      {renderStar('4')}
      {renderStar('3')}
      {renderStar('2')}
      {renderStar('1')}
    </div>
  );
}

OrderRatingStars.propTypes = {
  selectedRating: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
